import { generatePath, useHistory, useParams, useRouteMatch } from 'react-router-dom';

export interface ScheduleViewsUrlParams {
    viewId?: string;
}

export type SetViewIdUrlOptions = {
    replace?: boolean;
};

export const useScheduleViewIdUrlState = (): [
    viewId: string | undefined,
    setViewId: (value: string, options?: SetViewIdUrlOptions) => void,
] => {
    const { viewId } = useParams<ScheduleViewsUrlParams>();
    const history = useHistory();
    const { path } = useRouteMatch();

    const setViewId = (value: string, options?: SetViewIdUrlOptions) => {
        const newLocation = generatePath(path, { viewId: value });
        if (options?.replace) {
            history.replace(newLocation);
        } else {
            history.push(newLocation);
        }
    };

    return [viewId, setViewId];
};
